import { useRef } from "react";
import { angleOfTwoLinesFromThreePoints, distance2d, pointEquals } from "../../../geometry/operation";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { endRubberline, setToolMessage } from "../../../store/interaction";
import { insertShape } from "../../../store/model";
//import ArcBase from "../shapes/arc/ArcBase";
import CircleBase from "../shapes/circle/CircleBase";
import BaseLine from "../shapes/line/LineBase";
import { Transform } from "../../../geometry/transformation";
import { useSnapMousePosition } from "./useSnapMousePosition";
import { getShapeTransfomer } from "../util/shapeCategorySingleton";
import { RootState } from "../../../store/store";

const CircleRubber = () => {

    const dispatch = useAppDispatch();
    const rubberlinePoints = useAppSelector((state: RootState) => state.interaction.rubberlineData.snapPoints)
    const mousePosition = useAppSelector((state: RootState) => state.interface.mousePosition);
    const circleCurrentSetting = useAppSelector((state: RootState) => state.tool.toolSettings.circle.current);
    const arcCurrentSetting = useAppSelector((state: RootState) => state.tool.toolSettings.arc.current);
    const symbolLineSetting = useAppSelector((state: RootState) => state.tool.toolSettings.arc.symbolLine);
    const symbolCircleSetting = useAppSelector((state: RootState) => state.tool.toolSettings.arc.symbolCircle);
    const interaction = useAppSelector((state: RootState) => state.interaction)
    const mousePositionSnap = useSnapMousePosition();
    const startRotation = useRef<number>(0);
    const clockwise = useRef<boolean>(false);
    const previousRenderAngle = useRef<number>(0);
    const preViewArcCircle = useRef<CircleShape>(arcCurrentSetting);

    // Points coming from clicks on the stage
    const pointBuffer = interaction.rubberlineData.snapPoints;
    const translation = pointBuffer[0] ? Transform.translationTransform(rubberlinePoints[0].x, rubberlinePoints[0].y) : new Transform();
    const angle = (pointBuffer[0] && pointBuffer[1] && mousePosition && !pointEquals(pointBuffer[0], mousePosition)) ?
        angleOfTwoLinesFromThreePoints(pointBuffer[0], pointBuffer[1], mousePositionSnap) :
        0;

    // const arcProps: ArcShape = {
    //     ...arcCurrentSetting,
    //     transformation: translation.m
    // }
    const circleProps = {
        ...circleCurrentSetting,
        transformation: translation.m
    };


    switch (rubberlinePoints.length) {
        case 0: {
            dispatch(setToolMessage("define center point"))
            break;
        }
        case 1: {
            startRotation.current = angleOfTwoLinesFromThreePoints(pointBuffer[0], { x: pointBuffer[0].x - 1, y: pointBuffer[0].y }, mousePositionSnap)

            console.log("startRot", startRotation.current);

            dispatch(setToolMessage("set radius"))

            return (
                <>
                    <BaseLine
                        shapeProps={{
                            ...symbolLineSetting,
                            points: [rubberlinePoints[0], mousePositionSnap]
                        }} />
                    <CircleBase
                        shapeProps={{
                            ...symbolCircleSetting,
                            ...rubberlinePoints[0],
                            radius: distance2d(rubberlinePoints[0], mousePositionSnap)
                        }} />
                </>
            );
        }

        case 2: {

            // Change direction
            if (Math.sign(previousRenderAngle.current) !== Math.sign(angle)
                && Math.abs(angle) < 1
                && Math.abs(previousRenderAngle.current) < 1) {
                clockwise.current = Math.sign(angle) >= 0;
            }
            previousRenderAngle.current = angle;

            //let arcAngle = -angle * 180 / Math.PI
            let isCircle = false;
            if (Math.abs(angle) < 0.02) {
                //arcAngle = 360;
                isCircle = true;
            }
            if (!isCircle) {
                // preViewArcCircle.current = {
                //     ...arcProps,
                //     clockwise: clockwise.current,
                //     transformation: (Transform.rotationTransform(startRotation.current + Math.PI).multiply(translation)).m,
                //     radius: distance2d(rubberlinePoints[0], rubberlinePoints[1]),
                //     angle: arcAngle,
                // }

                // return (<ArcBase shapeProps={preViewArcCircle.current} />)
            } else {

                preViewArcCircle.current = {
                    ...circleProps,
                    radius: distance2d(rubberlinePoints[0], rubberlinePoints[1]),
                }
                return (<CircleBase shapeProps={preViewArcCircle.current} />)
            }
            break;
        }
        case 3: {
            // Set snap point
            preViewArcCircle.current = {
                ...preViewArcCircle.current,
                snapPoint: getShapeTransfomer(preViewArcCircle.current.type)?.snapPointCalculator(preViewArcCircle.current).snapPoint
            }
            dispatch(insertShape(preViewArcCircle.current))
            dispatch(endRubberline())
            break;
        }
        default:
            dispatch(endRubberline())
            break;
    }
    return <></>
}
const createCircleRubber = () => {

    return (<CircleRubber />)
}
export { createCircleRubber }
export default CircleRubber;